<button (click)="requestDoor()" mat-menu-item>DOOR {{doorStatus}}</button>